import { put } from "redux-saga/effects";
import { fingerPrintUnid } from "../../Services";

export function* FingerPrintUNID(action) {
  const payload = action.payload;
  console.log("tessss....");
  try {
    const res = yield fingerPrintUnid(payload);

    yield put({ type: "REQ_FINGERPRINT_UNID_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_FINGERPRINT_UNID_FAILED", errData: e });
  }
}
